<div class="mt-1">
  <label></label>
</div>
<div class="card">
  <h5 class="card-header title"><i
    class="fas fa-file-contract"></i> {{ "TITLE.DOCUMENT-VERIFICATION" | translate }}
  </h5>
  <div class="card-body custom-background custom-height">
    <div *ngIf="wrongVerification && !loading" class="alert alert-danger" role="alert">
      <i class="fa fa-exclamation-circle custom-icon-danger"></i>
      <b>
        {{verificationMessage | translate}}
      </b>
    </div>
    <div *ngIf="!wrongVerification && !loading && isModified && !isReplacerFinished"
         class="alert alert-danger font-weight-bold"
         role="alert">
      <i class="fa fa-exclamation-circle custom-icon-danger"></i>
      {{ "MESSAGE.DOCUMENT-HAS-BEEN-MODIFIED-AND-THAT-WILL-REPLACE-IS-BEING-PROCESSED" | translate }}
    </div>
    <div *ngIf="!wrongVerification && !loading && isModified && isReplacerFinished">
      <div id="listPanel">
        <ul class="list-group list-group-flush">
          <li class="list-group-item font-weight-bold">{{ "TITLE.MODIFICATION-HISTORY" | translate }}</li>
          <li class="list-group-item" *ngFor="let documentmodification of documentmodifications; let index=index">
            {{ "LABEL.DOCUMENT-DATED" | translate }}
            <b><i>{{documentmodification.documentByDocumentIdOld.createAt | dateformat}}</i></b>
            {{ "LABEL.WAS-MODIFIED-BY-THAT-OF-THE-DATE" | translate }}
            <b><i>{{documentmodification.documentByDocumentIdNew.createAt | dateformat}}</i></b> por
            {{ "LABEL.THE-MOTIVE" | translate }}
            <b><i>{{documentmodification.description ? '' : documentmodification.description}}</i></b>
          </li>
        </ul>
      </div>
      <div *ngIf="!wrongVerification && !loading && isModified && isReplacerFinished"
           class="alert alert-info mt-2 font-weight-bold"
           role="alert">
        <i class="fa fa-exclamation-circle custom-icon-danger"></i>
        {{ "MESSAGE.YOU-CAN-LOCATE-THE-VALID-DOCUMENT" | translate }}
        <a [href]="urlLastDocumentResource" target="_blank" rel="noopener">{{ "LINK.HERE" | translate }}!</a>
      </div>
    </div>
    <div class="mb-2 content-position-end" *ngIf="!wrongVerification && !isCanceled && !isModified">
      <button type="button" class="btn btn-outline-dark custom-button"
              (click)="verifyIntervalDownloadTime()" *ngIf="havePermissionToDownload">
        <i class="fa fa-download"></i> {{ "BUTTON.DOWNLOAD" | translate }}
      </button>
    </div>
    <div *ngIf="!wrongVerification && !isCanceled && !isModified" style="height: 90%">
      <div class="table-responsive {{operatorsInfo.length > 3 ? 'scroll-table' : 'scroll-table1'}}">
        <table class="table table-sm">
          <thead class="thead-custom-dark">
          <tr>
            <th scope="col">#</th>
            <th scope="col"></th>
            <th scope="col">{{ "TABLE.HEADER.OPERATION" | translate }}</th>
            <th scope="col">{{ "TABLE.HEADER.BY" | translate }}</th>
            <th scope="col">{{ "TABLE.HEADER.CERTIFYING-ENTITY" | translate }}</th>
            <th scope="col">TSA</th>
            <th scope="col">{{ "TABLE.HEADER.DATE-TIME" | translate }}</th>
            <th scope="col"></th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let operatorInfo of operatorsInfo; let index=index">
            <th scope="row">{{index + 1}}</th>
            <td class="custom-th">
              <i class="fa fa-check-circle custom-icon-success"></i>
            </td>
            <td>{{operatorInfo.operationDescription | translate}}</td>
            <td>{{operatorInfo.operatorName}}</td>
            <td>{{operatorInfo.issuerCertName}}</td>
            <td>{{operatorInfo.tsa}}</td>
            <td>{{operatorInfo.certainDateTime}}</td>
            <td>
              <span class="badge badge-info" [hidden]="hasntCertificate(operatorInfo)"
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title="Ver más"
                    (click)="openModalSeeCertificateDetail(index)">
              {{ "BUTTON.VIEW-MORE" | translate }}
              </span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="row">
        <div class="{{getClassMaxHeight(operatorsInfo)}} col-md-12 custom-col-3 custom-panel">
          <ng2-pdfjs-viewer [pdfSrc]="urlStream"
                            [download]="false"
                            [print]="false"
                            [openFile]="false"
                            [showSpinner]="true"
                            [viewBookmark]="false"
                            scroll="V"
                            (onDocumentLoad)="registerAdditionalData()"
                            viewerId="documentVisor">
          </ng2-pdfjs-viewer>
        </div>
      </div>
    </div>
  </div>
</div>
<app-loading *ngIf="loading"></app-loading>
